import { isFunction } from "./is.js";
import { wait } from "./wait.js";
async function nextTick(callback) {
  return wait().then(isFunction(callback) && callback);
}
export {
  nextTick
};
//# sourceMappingURL=nextTick.js.map
